/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesAuthAuthenticateFromTokenRequest interface.
 */
export function instanceOfFxIdWebFeaturesAuthAuthenticateFromTokenRequest(value) {
    if (!('TempToken' in value) || value['TempToken'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesAuthAuthenticateFromTokenRequestFromJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateFromTokenRequestFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateFromTokenRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'TempToken': json['TempToken'],
    };
}
export function FxIdWebFeaturesAuthAuthenticateFromTokenRequestToJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateFromTokenRequestToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateFromTokenRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'TempToken': value['TempToken'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesAuthAuthenticateFromTokenRequest.js.map